import { NumberFormatter, useNumberFormatter } from "client/Hooks";
import { getCurrentCulture } from "client_legacy/ndaw/culture";

export function useHubStatisticsFormatter(): NumberFormatter {
	return useNumberFormatter({
		culture: currentCulture,
		format: "compact",
		maxValue: 500_000_000
	});
}

const currentCulture: string = getCurrentCulture();